import { NextPage } from 'next'

import Footer from '@ui/components/shared/Footer'
import Header from '@ui/components/shared/Header'
import StaticContent from '@ui/components/static/StaticContent'
import css from 'styled-jsx/css'
import { useRouter } from 'next/router'
import { usePaygates } from '@ui/hooks'
import { useMemo } from 'react'

const StaticPage: NextPage = () => {
  const router = useRouter()
  const static_slug = router.query?.static_slug?.toString()
  const paygates = usePaygates()

  const page = useMemo(
    () =>
      !paygates?.paypalex && static_slug === 'payment-methods'
        ? 'payment-methods-without-paypal'
        : static_slug,
    [static_slug, paygates]
  )

  return (
    <div className="static-page">
      <style jsx global>
        {globalStyle}
      </style>
      <Header />

      <div className="wrapper">
        <div className="page__content section section--medium">
          <StaticContent page={page ?? ''} />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default StaticPage

const globalStyle = css.global`
  .static-page {
    .page__content {
      margin: auto;
      max-width: 650px;
      /* text-align: justify; */
    }

    .static-content {
      .content__title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 80px;
      }

      .item {
        margin-bottom: 40px;

        &__title {
          font-weight: bold;
          margin-bottom: 20px;
        }

        &__content {
          margin-bottom: 20px;
        }

        &__disc {
          list-style-type: disc;
          list-style-position: inside;
          display: list-item;
        }
      }

      a {
        color: #2d9cdb;
        text-decoration: underline;

        &.is-phone {
          color: var(--text);
          text-decoration: unset;
        }
      }

      ol {
        list-style-type: inherit;
      }

      .shop__name {
        color: #2d9cdb;
      }
    }
  }
`
